angular.module 'zc.projects.reports'

.controller 'ReportsCtrl', ($scope, $state, $q, $translate, Devise, Project, Campaign, Page, Report, ReportCampaignStats, ReportRange, currentProject, currencies) ->
  Page.setBodyClass ''
  $translate('projectsReports.controllers.list.repooto_ichiran').then((translation) ->
    Page.setTitle(translation)
  )

  CAN_SHOW_ZENCLERK_LP_INVOICE_AMOUNT_FROM = moment('2017/05/01', 'YYYY/MM/DD')

  $scope.Devise = Devise
  $scope.Project = Project
  $scope.currency = currencies[currentProject.currency]
  $scope.Report = Report
  $scope.currentProject = currentProject
  $scope.isAb = false

  $scope.canShowInvoiceAmount = (begin_at) ->
    moment(begin_at).isSameOrAfter(CAN_SHOW_ZENCLERK_LP_INVOICE_AMOUNT_FROM) or currentProject.product_line isnt 'zenclerk_lp'

  getReportCampaignStats = (report, dimension, status) ->
    ReportCampaignStats.find
      apikey: currentProject.apikey
      dimension: dimension
      campaign_id:
        '$in': report.campaign_ids
    ,
      match:
        status: status
        begin_at: report.begin_at
        start_at: report.start_at if report.start_at
        end_at: report.end_at

  if ReportRange.hasLatest()
    promises = for status in ['trial', 'contracted']
      matchQuery =
        target: null
        device: null
        status: status
        begin_at:
          $gte: ReportRange.getLatest().begin_at

      # When contracted_at is not yet set, it is needless to query for 'contracted'.
      break if status is 'contracted' and !currentProject.contracted_at

      if status is 'trial' and currentProject.contracted_at
        # filter out trial report_stats created after contracted_at
        matchQuery.start_at =
          $lt: currentProject.contracted_at

      Report.findOne
        apikey: currentProject.apikey
        dimension: 'daily'
      ,
        match: matchQuery
        sort:
          end_at: -1

    $q.all(promises).then ([trial_report_stats, contracted_report_stats]) ->
      checkAb(trial_report_stats, contracted_report_stats).then ->
        $scope.daily_reports =
          trial: trial_report_stats
          contracted: contracted_report_stats

  promises = for status in ['trial', 'contracted']
    Report.find
      apikey: currentProject.apikey
      dimension: 'monthly'
    ,
      match:
        target: null
        device: null
        status: status
      sort:
        begin_at: -1
    .then (monthly_reports) ->
      _.each monthly_reports, (report) ->
        getReportCampaignStats(report, 'monthly', status)
        .then (report_campaigns) ->
          return report if _.has(report_campaigns, '0.all_experimental')

          report.all_experimental = {
            conversion_price: _.sumBy report_campaigns, 'experimental.conversion_price'
            conversion_count: _.sumBy report_campaigns, 'experimental.conversion_count'
          }
          report

  $q.all(promises).then ([trial_report_stats, contracted_report_stats]) ->
    checkAb(trial_report_stats, contracted_report_stats).then ->
      $scope.monthly_reports =
        trial: trial_report_stats
        contracted: contracted_report_stats

  $scope.showReport = (report) ->
    reportId = moment(report.begin_at).tz(currentProject.region).valueOf()
    $state.go 'admin.projects.reports.show',
      projectId: $state.params.projectId
      reportId: reportId
      status: report.status

  checkAb = (trial_report_stats = [], contracted_report_stats = []) ->
    trialReportStats = trial_report_stats
    unless _.isArray(trialReportStats)
      trialReportStats = [trial_report_stats]

    stats = trialReportStats.concat(contracted_report_stats)
    campaign_ids = []
    campaign_ids = campaign_ids.concat(stat.campaign_ids) for stat in stats
    campaign_ids = _.uniq campaign_ids
    $q.all(_.map(campaign_ids, (campaign_id) ->
      Campaign.get(projectId: $state.params.projectId, campaignId: campaign_id)
    ))
    .then (campaigns) ->
      $scope.isAb = _.some campaigns, (campaign) ->
        campaign.campaign_control_percent isnt 0 and not campaign.is_secret_ab



// WEBPACK FOOTER //
// ./src/zenclerk_modules/projects.reports/list.controller.js.coffee